import clsx from 'clsx';
import type { ServiceType } from '@/types';
import { SERVICE_TYPE_LABELS, SERVICE_TYPE_COLORS } from '@/types';

interface ServiceBadgeProps {
  type: ServiceType;
  size?: 'sm' | 'md';
}

export function ServiceBadge({ type, size = 'md' }: ServiceBadgeProps) {
  return (
    <span
      className={clsx(
        'inline-flex items-center rounded-full font-medium',
        SERVICE_TYPE_COLORS[type],
        size === 'sm' ? 'px-2 py-0.5 text-xs' : 'px-3 py-1 text-sm'
      )}
    >
      {SERVICE_TYPE_LABELS[type]}
    </span>
  );
}
